import React from 'react'
import Carousel from 'react-bootstrap/Carousel';
import Image from 'react-bootstrap/Image'

const Carousels = () => {
    return (
        <div>
            <Carousel interval={null}>
                <Carousel.Item>
                    <Image className='d-block w-100' fluid alt='...' src={require('../../Images/Car1.JPG')} />
                    <Carousel.Caption style={{color:'#000'}} >
                        <h3>Prayers</h3>
                        <p className='fw-bold'>To give Ethics and Values to Students every day different Prayers are performed.</p>
                    </Carousel.Caption>
                </Carousel.Item>
                <Carousel.Item>
                    <Image className='d-block w-100'  fluid alt='...' src={require('../../Images/Car2.jpeg')}/>
                    <Carousel.Caption style={{color:'#383838'}}>
                        <h3>Quantam Leap Youth Parliament</h3>
                        <p className='fw-bold'>We have designed a Youth Parliament to enhance the public speaking of Students Very Frequently</p>
                    </Carousel.Caption>
                </Carousel.Item>
                <Carousel.Item>
                    <Image className='d-block w-100' fluid alt='...' src={require('../../Images/Car3.jpg')}/>
                    <Carousel.Caption>
                        <h3>Felicitation</h3>
                        <p className='fw-bold'>We award the Best Minds and Briiliant Talents to Boost Up their Confidence</p>
                    </Carousel.Caption>
                </Carousel.Item>
                <Carousel.Item>
                    <Image className='d-block w-100' fluid alt='...' src={require('../../Images/Car4.jpg')}/>
                    <Carousel.Caption>
                        <h3>Culturual Events</h3>
                        <p className='fw-bolder'>We Organise Events so that students can brush up their Co-Curricular Skills.</p>
                    </Carousel.Caption>
                </Carousel.Item>
                <Carousel.Item>
                    <Image className='d-block w-100' fluid alt='...' src={require('../../Images/Car5.jpg')}/>
                    <Carousel.Caption style={{color:'#000'}}>
                        <h3>Sports</h3>
                        <p className='fw-bolder'>We have a Good Playground Sturcture so that every one physical Strength can be boosted up.</p>
                    </Carousel.Caption>
                </Carousel.Item>
                <Carousel.Item>
                    <Image className='d-block w-100' fluid alt='...' src={require('../../Images/Car6.jpg')}/>
                    <Carousel.Caption style={{color:'#000'}}>
                        <h3>Transport</h3>
                        <p className='fw-bolder'>We have a best Transport System for Students and Teachers.</p>
                    </Carousel.Caption>
                </Carousel.Item>
            </Carousel>
        </div>
    )
}

export default Carousels